//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import { numFormat } from '~/utils/util';
export default {
  data() {
    return {
      list: [
        { text: '格隆贝账户', icon: 'g-icon-guru-coin', sideType: 'coin' },
        { text: '我的收藏', url: '/my/favorite', icon: 'g-icon-collection' },
        { text: '阅读历史', url: '/my/reading', icon: 'g-icon-record-reading' },
        // { text: '我的评论', url: '/my/comment', icon: '&#xe664;' },
        { text: '购买记录', url: '/my/purchase', icon: 'g-icon-record-paying' },
        { text: '优惠券', url: '/my/coupon', icon: 'g-icon-coupon' },
        { text: '资料设置', url: '/my/setting', icon: 'g-icon-settings' },
      ],
    };
  },
  computed: {
    ...mapGetters('user', [
      'userId',
      'avatar',
      'userBrief',
      'nickname',
      'followerCnt',
      'followingCnt',
      'postCnt',
      'stockCnt',
      'guruCoin',
      'vipInfo',
      'userLevel',
      'loginInfo',
    ]),

    /**
     * @description 千位分隔后的格隆币
     */
    formatCoin() {
      return numFormat(this.guruCoin);
    },
    /**
     * @description 判断是不是会员
     */
    isMember() {
      const now = new Date();
      const expTime = this.vipInfo.vipExpireTimestamp || null;
      return expTime && expTime * 1000 > now.getTime();
    },
    /**
     * @description 是否为大V
     */
    isBigV() {
      const bigV = this.loginInfo.showRoles
        ? this.loginInfo.showRoles.filter(item => item.type === 'BIG_V')
        : [];
      if (bigV.length > 0) {
        return bigV[0];
      }
      return null;
    },
  },
};
